import loadable from '@loadable/component';

export const CmsTwoTilesBlockLoadable = loadable(
  () => import('./CmsTwoTilesBlock'),
  { resolveComponent: (module) => module.CmsTwoTilesBlock },
);
